import { makeStyles } from 'tss-react/mui';

const useStylesChyronPreview = makeStyles()((theme) => ({
    chyron: {
        width: 'inherit',
        height: 29,
        overflow: 'hidden',
        borderRadius: 8,
        boxSizing: 'border-box',
        border: theme.custom.defaultBorder,
        WebkitMaskImage: '-webkit-radial-gradient(white, black)',
    },
    chyronContent: {
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: theme.custom.borderRadius,
        [theme.breakpoints.up('xl')]: {
            borderRadius: theme.custom.borderRadiusLarge,
        },
    }
}));

export default useStylesChyronPreview;